export default __webpack_public_path__ + "static/media/stopwatch.d0fd5115.svg";